import Vue from 'vue'
import Router from 'vue-router'
import {IS_MAINTENANCE_MODE} from "./config/app";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/pages/documents/documents-list/AllDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Listado', active: true }
                  ],
                  pageTitle: 'Todos',
                  rule: 'invited'
                }
              },
              {
                path: '/signed-documents',
                name: 'page-signed-documents',
                component: () => import('./views/pages/documents/documents-list/SignedDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Listado', active: true }
                  ],
                  pageTitle: 'Firmados',
                  rule: 'invited'
                }
              },
              {
                path: '/partial-documents',
                name: 'page-partial-documents',
                component: () => import('./views/pages/documents/documents-list/PartialDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Listado', active: true }
                  ],
                  pageTitle: 'Pendientes',
                  rule: 'invited'
                }
              },
              {
                path: '/reject-documents',
                name: 'page-reject-documents',
                component: () => import('./views/pages/documents/documents-list/RejectDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Listado', active: true }
                  ],
                  pageTitle: 'Rechazados',
                  rule: 'invited'
                }
              },
              {
                path: '/bulk-signature',
                name: 'page-containers',
                component: () => import('./views/pages/containers/containers-list/AllContainersList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma Masiva' },
                    { title: 'Listado', active: true }
                  ],
                  pageTitle: 'Firma Masiva',
                  rule: 'invited'
                }
              },
              {
                path: '/bulk-signature/create',
                name: 'create-container',
                component: () => import('./views/pages/containers/containers-create/CreateContainerWizard.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma Masiva' },
                    { title: 'Nuevo', active: true }
                  ],
                  pageTitle: 'Nueva Firma Masiva',
                  rule: 'invited'
                }
              },
              {
                path: '/invited',
                name: 'page-invited-documents',
                component: () => import('./views/pages/documents/documents-invited-list/AllDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Invitados', active: true }
                  ],
                  pageTitle: 'Documentos invitados',
                  rule: 'invited'
                }
              },
              {
                path: '/invited/signed-documents',
                name: 'page-invited-signed-documents',
                component: () => import('./views/pages/documents/documents-invited-list/SignedDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Invitados', active: true }
                  ],
                  pageTitle: 'Invitados firmados',
                  rule: 'invited'
                }
              },
              {
                path: '/invited/partial-documents',
                name: 'page-invited-partial-documents',
                component: () => import('./views/pages/documents/documents-invited-list/PartialDocumentsList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Invitados', active: true }
                  ],
                  pageTitle: 'Invitados pendientes',
                  rule: 'invited'
                }
              },
              {
                path: '/archived',
                name: 'page-archived-documents',
                component: () => import('./views/pages/documents/document-archived-list/AllDocumentArchivedList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Documentos' },
                    { title: 'Archivados', active: true }
                  ],
                  pageTitle: 'Documentos archivados',
                  rule: 'invited'
                }
              },
              {
                path: '/create-document',
                name: 'create-document',
                component: () => import('./views/pages/documents/documents-create/createDocument'),
                props: true,
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma' },
                    { title: 'Documento', active: true }
                  ],
                  pageTitle: 'Nueva firma',
                  rule: 'invited'
                }
              },
              {
                path: '/configuration/users',
                name: 'page-users',
                component: () => import('./views/pages/configuration/users/AllUsersList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Configuración' },
                    { title: 'Administrar', active: true }
                  ],
                  pageTitle: 'Usuarios',
                  rule: 'invited'
                }
              },
              {
                path: '/configuration/developers/api',
                name: 'api-key',
                component: () => import('./views/pages/configuration/api/ApiKey'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Configuración' },
                    { title: 'Administrar', active: true }
                  ],
                  pageTitle: 'API Key',
                  rule: 'invited'
                }
              },
              {
                path: '/configuration/defaults',
                name: 'defaults',
                component: () => import('./views/pages/configuration/default/DefaultConfig.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Configuración' },
                    { title: 'Administrar', active: true }
                  ],
                  pageTitle: 'Configuraciones por defecto',
                  rule: 'invited'
                }
              },
              {
                path: '/configuration/work-folders',
                name: 'page-companies',
                component: () => import('./views/pages/configuration/companies/AllCompaniesList'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Configuración' },
                    { title: 'Administrar', active: true }
                  ],
                  pageTitle: 'Carpetas de trabajo',
                  rule: 'invited'
                }
              },
              {
                path: '/configuration/tax-data',
                name: 'page-tax-data',
                component: () => import('./views/pages/configuration/tax-data/taxData'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Configuración' },
                    { title: 'Administrar', active: true }
                  ],
                  pageTitle: 'Datos Fiscales',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/documents',
                name: 'buy-credit-documents',
                component: () => import('./views/pages/buy/payment/PaymentCheckoutCreditPack'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Comprar' },
                    { title: 'Firmas', active: true }
                  ],
                  pageTitle: 'Comprar firmas',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/plans',
                name: 'buy-plans',
                component: () => import('./views/pages/buy/plans/plans'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Comprar' },
                    { title: 'Planes', active: true }
                  ],
                  pageTitle: 'Planes',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/success',
                name: 'users',
                component: () => import('./views/pages/buy/plans/PurchaseSuccess'),
                meta: {
                  rule: 'invited'
                }
              },
              {
                path: '/buy/purchases',
                name: 'buy-history',
                component: () => import('./views/pages/buy/purchases/purchases'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Compras' },
                    { title: 'Historial de compras', active: true }
                  ],
                  pageTitle: 'Compras',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/payment',
                name: 'payment',
                component: () => import('./views/pages/buy/payment/Payment'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Pago' },
                    { title: 'Pago contarjeta', active: true }
                  ],
                  pageTitle: 'Nueva Tarjeta',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/payment-method',
                name: 'payment-method',
                component: () => import('./views/pages/buy/payment/PaymentMethod'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Administrar' },
                    { title: 'Tarjetas', active: true }
                  ],
                  pageTitle: 'Métodos de pago',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/plan-payment',
                name: 'plan-payment',
                component: () => import('./views/pages/buy/payment/PaymentPlan'),
                props: true,
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Pago' },
                    { title: 'Pago con tarjeta', active: true }
                  ],
                  pageTitle: 'Método de pago',
                  rule: 'invited'
                }
              },
              {
                path: '/buy/creditpack-payment',
                name: 'credit-payment',
                component: () => import('./views/pages/buy/payment/PaymentCheckoutCreditPack'),
                props: true,
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Pago' },
                    { title: 'Pago con tarjeta', active: true }
                  ],
                  pageTitle: 'Método de pago',
                  rule: 'invited'
                }
              },
              {
                path: '/create-document/success',
                name: 'create-document-success',
                component: () => import('./views/pages/documents/components/SuccesSingDocument'),
                props: true,
                meta: {
                  rule: 'invited'
                }
              },
              {
                path: '/bulk-signature/success',
                name: 'create-container-success',
                component: () => import('./views/pages/containers/components/SuccessContainer.vue'),
                meta: {
                  rule: 'invited'
                }
              },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/auth/login/Login'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/register',
                name: 'page-register',
                component: () => import('@/views/pages/auth/register/Register'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/users/activation/:token',
                name: 'page-users-activation',
                component: () => import('@/views/pages/auth/password-create/CreatePasswordProcess'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/oauth2/redirect',
                name: 'page-oauth2',
                component: () => import('@/views/pages/auth/oauth2/Oauth2Redirect'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/questions',
                name: 'questions',
                component: () => import('@/views/pages/questions/Questions.vue'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/sms-verification',
                name: 'page-sms-verification',
                component: () => import('@/views/pages/auth/sms-verification/SmsVerification'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/taxdata-register',
                name: 'taxdata-register',
                component: () => import('@/views/pages/configuration/companies/FirstTaxData'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/work-folder-register',
                name: 'work-folder-register',
                component: () => import('@/views/pages/configuration/companies/FirstCompany'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/sign-document/:uuid',
                name: 'page-sign-document',
                component: () => import('@/views/pages/sign-document/SignDocumentPage'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma' },
                    { title: 'Documento', active: true }
                  ],
                  pageTitle: 'Firma de documento',
                  rule: "public"
                }

              },
              {
                path: '/sign-batch/:uuid/:signatureId',
                name: 'page-sign-document',
                component: () => import('@/views/pages/sign-document/SignBatchPage'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firmado Masivo' },
                    { title: 'Contenedor documentos', active: true }
                  ],
                  pageTitle: 'Firma masiva de documentos',
                  rule: "public"
                }

              },
              {
                path: '/sign-documents/:uuid/signature_flow/:signatureFlowId',
                name: 'page-signature-flow',
                component: () => import('@/views/pages/sign-document/flows/SignatureFlow'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma autógrafa' },
                    { title: 'Flujo de firmado', active: true }
                  ],
                  pageTitle: 'Firma autógrafa',
                  rule: "public"
                }
              },
              {
                path: '/sign-documents/:uuid/signature_flow/:signatureFlowId/verification/:localVerificationId',
                name: 'page-local-verification',
                component: () => import('@/views/pages/sign-document/flows/verification/LocalFlow'),
                meta: {
                  breadcrumb: [
                    { title: 'CheckSquare', url: '/' },
                    { title: 'Firma autógrafa' },
                    { title: 'Flujo de firmado', active: true }
                  ],
                  pageTitle: 'Firma autógrafa',
                  rule: "public"
                }
              },
              {
                path: '/verify/:uuid',
                name: 'page-show-document',
                component: () => import('@/views/pages/documents/document-show/ShowDocument'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/register/success',
                name: 'register-success',
                component: () => import('@/views/pages/Success.vue'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/forgot-password',
                name: 'forgot-password',
                component: () => import('@/views/pages/auth/forgot-password/ForgotPassword.vue'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/forgot-password/:token',
                name: 'reset-password',
                component: () => import('@/views/pages/auth/forgot-password/ResetPassword.vue'),
                meta: {
                  rule: 'public'
                }
              },
              {
                path: '/maintenance',
                name: 'Maintenance',
                component: () => import('@/views/pages/Maintenance'),
                meta: {
                  rule: 'public'
                }
              }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.beforeEach((to, from, next) => {
  if (IS_MAINTENANCE_MODE) {
    if (to.matched[1].path !== '/maintenance') {
      return next('/maintenance');
    } else {
      return next();
    }
  }
  // Redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/invite','/forgot-password', '/email/verification', '/oauth2/redirect', '/sign-document/:uuid', '/sign-batch/:uuid/:signatureId', '/verify/:uuid', '/users/activation/:token', '/register/success', '/forgot-password/:token', '/sign-documents/:uuid/signature_flow/:signatureFlowId', '/sign-documents/:uuid/signature_flow/:signatureFlowId/verification/:localVerificationId'];
  const authRequired = !publicPages.includes(to.matched[1].path);
  const loggedIn = localStorage.getItem('user');
  const user = JSON.parse(loggedIn);

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  if (authRequired && user && !user.me.phone && to.matched[1].path !== '/sms-verification') {
    return next('/sms-verification');
  } else if (authRequired && user && user.me.phone && !user.me.on_boarding && to.matched[1].path !== '/questions') {
    return next('/questions');
  } else if (authRequired && user && user.me.phone && user.me.on_boarding && !user.me.owned_companies.length && !user.me.invited_companies.length && to.matched[1].path !== '/work-folder-register') {
    return next('/work-folder-register');
  }
  return next();
})

router.afterEach((to) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
      appLoading.style.display = "none";
  }

  const publicPages = ['/login', '/register', '/invite','/forgot-password', '/email/verification', '/oauth2/redirect', '/sign-document/:uuid', '/verify/:uuid', '/users/activation/:token', '/register/success', '/forgot-password/:token'];
  const authRequired = !publicPages.includes(to.matched[1].path);

  if (to.matched[1].path.includes("/buy")) {
    return;
  }

  if (authRequired && !router.app.$store.state.account.user.me.active) {
    router.app.$modal.show('demoEnding');
  }

})

export default router
